import React from 'react';
import PropTypes from 'prop-types';
import * as types from '../../../constants/actionTypes';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { actions as projectActions } from '../../../actions/projectActions';
import { actions as projectTagActions } from '../../../actions/projectTagActions';
import { actions as windowActions } from '../../../actions/windowActions';
import ProjectsForm from './ProjectsForm';
import { DEFAULT_PAGE_SIZE, MOBILE_WINDOW_BREAKPOINT } from '../../../constants/constants';
import Routes from '../../../constants/routes';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import Drawer from '../../Common/Drawer/Drawer';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import Icon from '../../Common/Icon';
import Notification from '../../../components/Common/Notification';
import { Menu } from 'primereact/menu';
import { isValidUrl } from '../../../helpers/validation';
import DocumentTitle from 'react-document-title';
import { getDataTableSortFields, getSearchParamSortFields } from '../../../helpers/sortHelper';
import CustomMultiSelect from '../../Common/PrimeMultiselectBox/CustomMultiSelect';
import Modal61 from '../../Common/Modal/Modal61';
import InputText from '../../Common/InputText';
import ColorChooser from '../../Common/ColorChooser';
import Tag from '../../Common/Tag/Tag';
import { CUSTOMER_ROLES } from '../../../constants/roles';

const MENUOPTIONS = {
	Dashboard: 'dashboard',
	Edit: 'edit',
	InScope: 'inScope',
	Copy: 'copy',
};

export class Projects extends React.Component {
	constructor(props, context) {
		super(props, context);

		const newProject = {
			id: 0,
			name: '',
			description: '',
			abbreviation: '',
			canRequestProjectWaiver: false,
			isActive: true,
			subscriptionId: props.subscriptionId,
			projectManagerId: '',
			projectManagerName: '',
			supportAgentId: 0,
			supportAgentName: '',
			resources: [
				{
					id: 0,
					name: '',
					url: '',
					isActive: true,
					ordinal: 0,
				},
			],
			projectEpicLabels: [
				{
					id: 0,
					name: '',
					isActive: true,
					ordinal: 0,
				},
			],
			dateInactive: null,
			createdBy: '',
			createdDate: null,
			projectTagIds: [],
			zeroDateName: '',
		};

		this.state = {
			currentUserId: props.currentUserId,
			projects: [],
			projectManagers: [],
			supportAgents: [],
			projectTags: [],
			totalCount: 0,
			isProjectWaiversActive: false,
			IsProjectReferenceDatesActive: false,
			isFetching: false,
			isSaving: false,
			selectedProject: newProject,
			editProject: newProject,
			newProject: newProject,
			drawerOpen: false,
			isCopyProjectDrawerOpen: false,
			isFormValid: true,
			searchParams: {
				subscriptionId: props.subscriptionId,
				isActive: true,
				projectName: '',
				abbreviation: '',
				description: '',
				projectManagerIds: this.props.selectedProjectManagers,
				pageSize: DEFAULT_PAGE_SIZE,
				pageNumber: 1,
				sortBy: 'name',
				sortDir: 'asc',
			},
			isAddNewTagModalLoading: false,
			newProjectTag: {
				name: '',
				bgColor: '#5F0DF0',
				fontColor: '#ffffff',
			},
			isNewTagFormValid: true,
		};
		this.search.bind(this);
		this.loadFilters.bind(this);

		this.tagModal = React.createRef();
	}

	async componentDidMount() {
		await this.loadFilters();
		await this.search();
	}

	async search() {
		try {
			this.setState({ isFetching: true });

			const result = await this.props.projectActions.searchProjects(this.state.searchParams);
			const payload = result.payload;
			if (result.type === types.SEARCH_PROJECT_SUCCESS) {
				this.setState({ projects: payload.results, totalCount: payload.totalCount });
			} else if (result.type === types.SEARCH_PROJECT_FAILURE) {
				Notification('error', 'An Error Occurred', payload.message);
			}
		} catch (error) {
			Notification('error', 'An Error Occurred', error);
		} finally {
			this.setState({ isFetching: false });
		}
	}

	async loadFilters() {
		try {
			this.setState({ isFetching: true });
			const result = await this.props.projectActions.loadProjectListFilters(this.props.subscriptionId);
			const payload = result.payload;
			if (result.type === types.LOAD_PROJECT_FILTERS_SUCCESS) {
				const addNewTagOption = {
					id: -9999,
					name: '+ Add New Project Tag',
					styles: {
						backgroundColor: '#F7F5FF',
						color: '#46389E',
					},
				};

				this.setState({
					projectManagers: payload.projectManagers,
					supportAgents: payload.supportAgents,
					totalCount: payload.totalCount,
					isProjectWaiversActive: payload.isProjectWaiversActive,
					IsProjectReferenceDatesActive: payload.isProjectReferenceDatesActive,
					projectTags: [...payload.tags, addNewTagOption],
				});
			} else if (result.type === types.LOAD_PROJECT_FILTERS_FAILURE) {
				Notification('error', 'An Error Occurred', payload.message);
			}
		} catch (error) {
			Notification('error', 'An Error Occurred', error);
		} finally {
			this.setState({ isFetching: false });
		}
	}

	async save() {
		let project = this.state.editProject;
		// remove all blank resources
		project.resources = project.resources.filter((x) => x.name && x.name.trim().length > 0 && x.url && x.url.trim().length > 0);
		project.projectEpicLabels = project.projectEpicLabels.filter((x) => x.name && x.name.trim().length > 0);
		const result = await this.props.projectActions.saveProject(project);

		if (result.type === types.CREATE_PROJECT_SUCCESS || result.type === types.UPDATE_PROJECT_SUCCESS) {
			Notification('success', 'Save Successful', 'Project saved successfully');

			if (project.isActive) {
				setTimeout(() => {
					const pmDashBoardUrl = window.location.origin + '/admin/pm-dashboard/' + result.payload.project.projectKey;
					window.location.assign(pmDashBoardUrl);
				}, 3000);
			}

			this.setState({ drawerOpen: false });
		} else if (result.type === types.UPDATE_PROJECT_FAILURE || result.type === types.CREATE_PROJECT_FAILURE) {
			this.setState({ errorMessage: result.payload.message });
			Notification('error', 'An Error Occurred', result.payload.message);
		}
	}

	async saveCopy() {
		let project = this.state.editProject;
		// remove all blank resources
		project.resources = project.resources.filter((x) => x.name && x.name.trim().length > 0 && x.url && x.url.trim().length > 0);
		const result = await this.props.projectActions.copyProject(project);

		if (result.type === types.COPY_PROJECT_SUCCESS) {
			Notification('success', 'Copy Successful', 'Project copied successfully');
			this.setState({ isCopyProjectDrawerOpen: false });
			this.setState({ searchParams: { ...this.state.searchParams, pageNumber: 1 } }, () => {
				this.search();
			});
		} else if (result.type === types.COPY_PROJECT_FAILURE) {
			this.setState({ errorMessage: result.payload.message });
			Notification('error', 'An Error Occurred', result.payload.message);
		}
	}

	filterChange = (e) => {
		let name = e.target.name;
		this.setState({ searchParams: { ...this.state.searchParams, [name]: e.target.value } });
	};

	onSearchBlur = () => {
		this.setState({ searchParams: { ...this.state.searchParams, pageNumber: 1 } }, () => {
			this.search();
		});
	};

	keyUpFilter = (e) => {
		if (e.keyCode == 13) {
			this.setState({ searchParams: { ...this.state.searchParams, pageNumber: 1 } }, () => {
				this.search();
			});
		}
	};

	onActiveChange = (e) => {
		this.setState({ searchParams: { ...this.state.searchParams, isActive: e.value } }, () => {
			this.search();
		});
	};

	onTriggerSearchFromCustomComponent = (clicked) => {
		if (clicked) {
			this.search();
		}
	};

	onProjectManagerChange = (e) => {
		const projMgrIds = e.value.map((x) => x.id);
		this.setState({ searchParams: { ...this.state.searchParams, projectManagerIds: projMgrIds } });

		//set value in app state
		this.props.projectActions.setProjectManagerFilter(projMgrIds);
	};

	onPageChange = (e) => {
		this.setState({ searchParams: { ...this.state.searchParams, pageNumber: e.page + 1 } }, () => {
			this.search();
		});
	};

	onAddNew = () => {
		this.setState({
			selectedProject: null,
			editProject: { ...this.state.newProject, supportAgentId: this.state.currentUserId },
			drawerOpen: true,
			errorMessage: '',
			isFormValid: true,
			editAction: 'edit',
		});
	};

	onFormChange = (name, value) => {
		if (name === 'projectTagIds' && value.includes('-9999')) {
			// User selected the add new option for project tags
			this.tagModal.current.show();
		} else {
			this.setState({ editProject: { ...this.state.editProject, [name]: value } });
		}
	};

	onNewTagFormChange = (name, value) => {
		this.setState({ newProjectTag: { ...this.state.newProjectTag, [name]: value } });
	};

	onActiveFilterChange = (e) => {
		this.setState({ searchParams: { ...this.state.searchParams, isActive: e.value } }, () => {
			this.search();
		});
	};

	// ------- Drawer
	urlsValid = (resources) => {
		if (!resources || !resources.length) {
			return true; // It's valid to have no resources
		}
		for (let i = 0; i < resources.length; i++) {
			const r = resources[i];
			if (r.url !== '' && !isValidUrl(r.url)) {
				return false;
			}
		}
		return true;
	};

	saveClick = () => {
		const urlsValid = this.urlsValid(this.state.editProject.resources);
		if (
			!urlsValid ||
			this.state.editProject.name.trim().length < 1 ||
			this.state.editProject.abbreviation.trim().length < 1 ||
			this.state.editProject.projectManagerId === ''
		) {
			this.setState({ isFormValid: false });
			return;
		}

		this.setState({ isFormValid: true });
		this.save();
	};

	cancelClick = () => {
		this.setState({
			drawerOpen: false,
			editProject: { ...this.state.newProject }, // Reset editProject to the default
		});
	};

	saveCopyClick = () => {
		const urlsValid = this.urlsValid(this.state.editProject.resources);
		if (
			!urlsValid ||
			this.state.editProject.name.trim().length < 1 ||
			this.state.editProject.abbreviation.trim().length < 1 ||
			this.state.editProject.projectManagerId === ''
		) {
			this.setState({ isFormValid: false });
			return;
		}

		this.setState({ isFormValid: true });
		this.saveCopy();
	};

	cancelCopyClick = () => {
		this.setState({ isCopyProjectDrawerOpen: false, editProject: null });
	};

	selectProject = (e) => {
		const isEllipsisClick =
			e.originalEvent.target.className.indexOf('ellipsis-h') >= 0 || e.originalEvent.target.className.indexOf('ellipsis') >= 0;
		if (isEllipsisClick === true) {
			return;
		}

		// fires when user clicks a row in the datatable, but only on mobile do we show the menu
		// non mobile they need to click the actions button which calls onActionsClick
		if (this.state.windowWidth < 500 && e.value != null) {
			let project = e.value;
			if (!project.resources || !project.resources.length) {
				project.resources = this.state.newProject.resources;
			}
			this.setState({ selectedProject: project, editProject: project });
			this.menu.toggle(e.originalEvent);
		} else {
			// Will be updated once Rich approves, for now commented
			// this.props.history.push(Routes.Admin + '/project-dashboard/' + e.value.projectKey);
			this.props.history.push(Routes.Admin + '/pm-dashboard/' + e.value.projectKey);
		}
	};
	// ------- Drawer

	activeTemplate = (rowData) => {
		if (rowData.isActive) {
			return (
				<div className='text-success text-center'>
					<Icon name='check-circle' />
				</div>
			);
		} else {
			return (
				<div className='text-danger text-center'>
					<Icon name='times-circle' />
				</div>
			);
		}
	};

	onActionsClick = (rowData, e) => {
		this.menu.toggle(e);

		// Reset selectedProject and editProject
		const selectedProject = { ...this.state.newProject, ...rowData }; // Merge newProject default values with selected project
		selectedProject.zeroDateName = rowData.zeroDateName || ''; // Ensure zeroDateName is explicitly set

		if (!selectedProject.resources || !selectedProject.resources.length) {
			selectedProject.resources = this.state.newProject.resources;
		}

		this.setState({
			selectedProject,
			editProject: selectedProject, // Ensure the editProject is reset
			editAction: MENUOPTIONS.Edit,
			isFormValid: true,
		});
	};

	actionTemplate = (rowData) => {
		return (
			<div className='text-center ellipsis' onClick={(e) => this.onActionsClick(rowData, e)}>
				<Icon name='ellipsis-h' />
			</div>
		);
	};

	menuOptionClick = (e) => {
		switch (e.item.value) {
			case MENUOPTIONS.Edit:
				this.setState({ editAction: e.item.value, drawerOpen: true, isFormValid: true });
				break;
			case MENUOPTIONS.InScope:
				this.props.history.push(Routes.Admin + '/project/' + this.state.selectedProject.projectKey + '/project-locations');
				break;
			case MENUOPTIONS.Dashboard:
				this.props.history.push(Routes.Admin + '/pm-dashboard/' + this.state.selectedProject.projectKey);
				break;
			case MENUOPTIONS.Copy:
				this.setState({ editAction: e.item.value, isCopyProjectDrawerOpen: true, isFormValid: true });
				break;
			default:
				this.setState({ editAction: e.item.value });
		}
	};

	nameTemplate = (rowData) => {
		return (
			<span className='datatable-link' onClick={() => this.onNameClick(rowData)}>
				{rowData.name}
			</span>
		);
	};

	onNameClick = (rowData) => {
		this.props.history.push(Routes.Admin + '/pm-dashboard/' + rowData.projectKey);
	};

	onSort = ({ sortField, sortOrder }) => {
		const { sortBy, sortDir } = getSearchParamSortFields(sortField, sortOrder);
		if (sortBy !== this.state.searchParams.sortBy || sortDir !== this.state.searchParams.sortDir) {
			this.setState(
				{
					searchParams: {
						...this.state.searchParams,
						sortBy: sortBy,
						sortDir: sortDir,
					},
				},
				this.search
			);
		}
	};

	getColumnFilterMultiSelectValues = (sourceIds, columnFiltersValues) => {
		let results = [];
		if (sourceIds && sourceIds.length && columnFiltersValues && columnFiltersValues.length) {
			for (let i = 0; i < sourceIds.length; i++) {
				const value = columnFiltersValues.find((m) => m.id.toString() === sourceIds[i].toString());
				if (value) {
					results.push(value);
				}
			}
		}
		return results;
	};

	onCreateNewProjectTag = async () => {
		if (!this.validateCreateNewTagForm()) return false;

		this.setState({ isAddNewTagModalLoading: true });

		const projectTag = {
			id: 0,
			name: this.state.newProjectTag.name,
			fontColor: this.state.newProjectTag.fontColor,
			backgroundColor: this.state.newProjectTag.bgColor,
			isActive: true,
		};

		try {
			const result = await this.props.projectTagActions.saveProjectTag(projectTag);

			if (result.type === types.CREATE_PROJECT_TAG_SUCCESS) {
				Notification('success', 'Save Successful', 'Project Tag created');
				this.setState({ isAddNewTagModalLoading: false });
				this.tagModal.current.hide();
				await this.loadFilters();
			} else if (result.type === types.CREATE_PROJECT_TAG_FAILURE) {
				Notification('error', 'An Error Occurred', result.payload.message);
			}
		} catch (error) {
			Notification('error', 'An Error Occurred', error);
		}
	};

	validateCreateNewTagForm = () => {
		if (this.state.newProjectTag.name.trim().length < 1) {
			this.setState({ isNewTagFormValid: false });
			return false;
		} else {
			return true;
		}
	};

	render() {
		const displayColumns = this.props.windowWidth < MOBILE_WINDOW_BREAKPOINT ? 'none' : '';

		const activeOptions = [
			{ label: 'Yes', value: true },
			{ label: 'No', value: false },
			{ label: 'All', value: null },
		];

		const menuOptions = [
			{ label: 'Dashboard', value: MENUOPTIONS.Dashboard, command: this.menuOptionClick },
			{ label: 'Edit', value: MENUOPTIONS.Edit, command: this.menuOptionClick },
			{ label: 'In Scope Locations', value: MENUOPTIONS.InScope, command: this.menuOptionClick },
			{ label: 'Copy', value: MENUOPTIONS.Copy, command: this.menuOptionClick },
		];

		const activeFilter = (
			<Dropdown
				name='isActive'
				className='ui-column-filter w-100'
				value={this.state.searchParams.isActive}
				style={{ textAlign: 'center', width: '76px' }}
				options={activeOptions}
				onChange={this.onActiveFilterChange}
			/>
		);

		const nameFilterElement = (
			<div>
				<input
					type='text'
					name='projectName'
					className='p-inputtext p-component p-column-filter'
					placeholder='Filter by Name'
					onBlur={this.onSearchBlur}
					onChange={this.filterChange}
					onKeyUp={this.keyUpFilter}
					value={this.state.searchParams.projectName}
				/>
			</div>
		);

		const abbreviationFilter = (
			<div>
				<input
					type='text'
					name='abbreviation'
					className='p-inputtext p-component p-column-filter'
					placeholder='Filter by Abbreviation'
					onBlur={this.onSearchBlur}
					onChange={this.filterChange}
					onKeyUp={this.keyUpFilter}
					value={this.state.searchParams.abbreviation}
				/>
			</div>
		);

		const descriptionFilter = (
			<div>
				<input
					type='text'
					name='description'
					className='p-inputtext p-component p-column-filter'
					placeholder='Filter by Description'
					onBlur={this.onSearchBlur}
					onChange={this.filterChange}
					onKeyUp={this.keyUpFilter}
					value={this.state.searchParams.description}
				/>
			</div>
		);

		const projectManagerFilterValues = this.getColumnFilterMultiSelectValues(
			this.state.searchParams.projectManagerIds,
			this.state.projectManagers
		);

		const projectManagerNameFilter = (
			<CustomMultiSelect
				value={projectManagerFilterValues}
				options={this.state.projectManagers}
				onChange={this.onProjectManagerChange}
				onButtonClick={this.onTriggerSearchFromCustomComponent}
				className='ui-column-filter'
				optionLabel='name'
				placeholder='Filter'
				dataKey='id'
				style={{ width: '100%' }}
				maxSelectedLabels={2}></CustomMultiSelect>
		);

		const { sortField, sortOrder } = getDataTableSortFields(this.state.searchParams);

		return (
			<div>
				<DocumentTitle title='Admin' />
				<Menu model={menuOptions} popup={true} ref={(el) => (this.menu = el)} />
				{this.state.drawerOpen && (
					<Drawer isWide={false} title='Project' onSaveClick={this.saveClick} onCancelClick={this.cancelClick}>
						<ProjectsForm
							project={this.state.editProject}
							projectManagers={this.state.projectManagers}
							supportAgents={this.state.supportAgents}
							onFormChange={this.onFormChange}
							isFormValid={this.state.isFormValid}
							onSubmit={this.saveClick}
							isProjectWaiversActive={this.state.isProjectWaiversActive}
							IsProjectReferenceDatesActive={this.state.IsProjectReferenceDatesActive}
							projectTags={this.state.projectTags}
						/>
					</Drawer>
				)}

				{this.state.isCopyProjectDrawerOpen && (
					<Drawer isWide={false} title='Copy Project' onSaveClick={this.saveCopyClick} onCancelClick={this.cancelCopyClick} saveText='Copy'>
						<ProjectsForm
							project={this.state.editProject}
							projectManagers={this.state.projectManagers}
							supportAgents={this.state.supportAgents}
							onFormChange={this.onFormChange}
							isFormValid={this.state.isFormValid}
							onSubmit={this.saveClick}
							IsProjectReferenceDatesActive={this.state.IsProjectReferenceDatesActive}
						/>
					</Drawer>
				)}

				<div>
					<div className='identifier-header'>
						<div className='title'>Projects</div>
						<div className='close'>
							<button type='button' onClick={this.props.onClose} alt='close popup'>
								<Icon name='times' />
							</button>
						</div>
					</div>

					<div className='identifier-add-new'>
						<div className='col-sm-12'>
							<button type='button' className='btn btn-primary' onClick={this.onAddNew} alt='close popup'>
								<span className='me-2'>Add New</span>
								<Icon name='plus-circle' />
							</button>
						</div>
					</div>

					<LoadingIndicator isLoading={this.state.isFetching} hideWhileLoading={true}>
						<div className='identifier-results-table'>
							<DataTable
								filterDisplay="row"
								className='p-datatable-sm p-datatable-striped'
								value={this.state.projects}
								selectionMode='single'
								selection={this.state.selectedProject}
								onSelectionChange={this.selectProject}
								sortField={sortField}
								sortOrder={sortOrder}
								onSort={this.onSort}>
								<Column
									field='name'
									header='Name'
									filter={true}
									filterElement={nameFilterElement}
									body={this.nameTemplate}
									sortable={true}
								/>
								<Column
									field='abbreviation'
									header='Abbreviation'
									filter={true}
									filterElement={abbreviationFilter}
									sortable={true}
									style={{ display: displayColumns }}
								/>
								<Column
									field='description'
									header='Description'
									filter={true}
									filterElement={descriptionFilter}
									sortable={true}
									style={{ display: displayColumns }}
								/>
								<Column
									field='projectManagerName'
									header='Manager'
									filterField='projectManagerName'
									showFilterMatchModes={false}
									filter={true}
									filterElement={projectManagerNameFilter}
									style={{ display: displayColumns }}
								/>
								<Column
									field='inScopeLocations'
									header='In Scope'
									style={{ width: '130px', display: displayColumns }}
									sortable={true}
								/>
								<Column field='pushedLocations' header='Pushed' style={{ width: '120px', display: displayColumns }} sortable={true} />
								<Column
									field='isActive'
									header='Active'
									body={this.activeTemplate}
									style={{ width: '120px' }}
									filter={true}
									filterElement={activeFilter}
									sortable={true}
								/>
								<Column field='dotdotdot' header='Actions' body={this.actionTemplate} style={{ width: '6em' }} />
							</DataTable>
							{this.state.totalCount > this.state.searchParams.pageSize && (
								<Paginator
									rows={this.state.searchParams.pageSize}
									totalRecords={this.state.totalCount}
									first={(this.state.searchParams.pageNumber - 1) * this.state.searchParams.pageSize}
									onPageChange={this.onPageChange}
								/>
							)}
							<div className='results-count'>Total records: {this.state.totalCount}</div>
						</div>
					</LoadingIndicator>
				</div>

				<Modal61
					title='Create New Project Tag'
					ref={this.tagModal}
					body={
						<form name='newProjectManagerForm' noValidate className={this.state.isNewTagFormValid ? '' : 'was-validated'}>
							<div className='mb-3'>
								<label htmlFor='project-tag-name' className='title'>
									Project Tag Name
								</label>
								<InputText
									name='project-tag-name'
									type='text'
									value={this.state.newProjectTag.name}
									onChange={(e) => this.onNewTagFormChange('name', e.target.value)}
									isRequired={true}
									errorMessage='Project Tag Name is required'
									maxLength={50}
								/>
								<small id='project-tag-name-help' className='form-text text-muted sub-title'>
									Character Limit 50
								</small>
							</div>
							<ColorChooser
								name='backgroundColor'
								title='Background Color'
								selectedColor={this.state.newProjectTag.bgColor}
								onChange={(color) => this.onNewTagFormChange('bgColor', color)}
							/>
							<ColorChooser
								name='fontColor'
								title='Font Color'
								selectedColor={this.state.newProjectTag.fontColor}
								onChange={(color) => this.onNewTagFormChange('fontColor', color)}
							/>
							<div className='mt-5'>
								<span className='me-2'>Preview:</span>
								<Tag
									title={this.state.newProjectTag.name}
									backgroundColor={this.state.newProjectTag.bgColor}
									color={this.state.newProjectTag.fontColor}
								/>
							</div>
						</form>
					}
					primaryButtonText='Save'
					onPrimaryClick={() => this.onCreateNewProjectTag()}
					showSecondaryButton={true}
					isLoading={this.state.isAddNewTagModalLoading}
				/>
			</div>
		);
	}
}

Projects.propTypes = {
	subscriptionId: PropTypes.number.isRequired,
	currentUserId: PropTypes.number.isRequired,
	user: PropTypes.object.isRequired,
	projectActions: PropTypes.object.isRequired,
	projectTagActions: PropTypes.object.isRequired,
	windowWidth: PropTypes.number.isRequired,
	onClose: PropTypes.func.isRequired,
	history: PropTypes.object.isRequired,
	selectedProjectManagers: PropTypes.array,
};

function mapStateToProps(state, ownProps) {
	return {
		windowWidth: state.window.width,
		history: ownProps.history,
		currentUserId: state.user.id,
		selectedProjectManagers: state.projects.projectManagers,
		user: state.user,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		projectActions: bindActionCreators(projectActions, dispatch),
		projectTagActions: bindActionCreators(projectTagActions, dispatch),
		windowActions: bindActionCreators(windowActions, dispatch),
	};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Projects));
